import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/partnership/components/SuccessStoriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/components/ui/AppIcon.tsx");
